<template>
  <section class="nav-menu">
    <p
      @click="toggle_mapstyle"
      class="map_style is-pointer"
      v-tooltip="{ content: mapstyle == 'satellite' ? 'Street' : 'Satellite' }"
    >
      <img v-if="mapstyle == 'street'" src="@/assets/satellite.jpg" />
      <img v-else src="@/assets/street.jpg" />
    </p>

    <b-tabs v-model="activeTab" class="block nav-menu__tabs">
      <b-tab-item label="Vectors">
        <vector-list></vector-list>
      </b-tab-item>
      <b-tab-item label="Orthos">
        <group-list></group-list>
      </b-tab-item>
      <b-tab-item label="Actions">
        <div class="buttons option-buttons card-content">
          <a
            class="button is-warning is-small is-fullwidth"
            :class="{ 'is-loading': is_loading_1 }"
            @click="reset_features_properties"
          >
            <span class="icon is-small">
              <i class="fa fa-minus-circle"></i>
            </span>
            <span>Clear meta properties</span>
          </a>
          <a
            class="button is-warning is-small is-fullwidth"
            :class="{ 'is-loading': is_loading_1 }"
            @click="reset_features_uids"
          >
            <span class="icon is-small">
              <i class="fa fa-minus-circle"></i>
            </span>
            <span>Clear Current Features UID</span>
          </a>
          <a
            class="button is-small is-danger is-fullwidth"
            :class="{ 'is-loading': is_loading_2 }"
            @click="delete_all_features"
          >
            <span class="icon is-small">
              <i class="fa fa-trash"></i>
            </span>
            <span>Delete Current Map Features</span>
          </a>
          <a
            style="background-color: orange"
            class="button is-small is-fullwidth"
            :class="{ 'is-loading': is_loading_1 }"
            @click="clear_features_elements"
          >
            <span class="icon is-small">
              <i class="fa fa-minus-circle"></i>
            </span>
            <span>Clear elements</span>
          </a>
        </div>
      </b-tab-item>
    </b-tabs>
  </section>
</template>

<script>
import VectorList from "./components/vectors/vector-list.component";
import GroupList from "./components/group/group-list.component";
import { mapState } from "vuex";

export default {
  data() {
    return {
      mapstyle: "satellite",
      activeTab: 1,
      is_loading_1: false,
      is_loading_2: false,
    };
  },
  components: {
    "vector-list": VectorList,
    "group-list": GroupList,
  },
  computed: {
    ...mapState(["map"]),
  },
  methods: {
    toggle_mapstyle() {
      if (this.mapstyle.includes("street")) {
        this.mapstyle = "satellite";
        this.map.setStyle("mapbox://styles/mapbox/satellite-v8");

        // this.map.setLayoutProperty(
        //   "satellite",
        //   "visibility",
        //   "visible"
        // );
      } else {
        this.mapstyle = "satellite";

        this.map.setStyle("mapbox://styles/mapbox/streets-v11");

        this.mapstyle = "street";
        //   this.map.setLayoutProperty(
        //     "satellite",
        //     "visibility",
        //     "none"
        //   );
      }
    },
    reset_features_uids() {
      this.is_loading_1 = true;
      setTimeout(() => {
        this.is_loading_1 = false;
        let draw = this.$store.state.draw;
        let featuresCollection = draw.getAll();
        for (let i in featuresCollection.features) {
          delete featuresCollection.features[i].properties.uid;
          delete featuresCollection.features[i].properties.row;
          delete featuresCollection.features[i].properties.column;
          delete featuresCollection.features[i].properties.table_row;
          delete featuresCollection.features[i].properties.table_column;
          delete featuresCollection.features[i].properties.idx;
          delete featuresCollection.features[i].properties.num_modules_affected;
          delete featuresCollection.features[i].properties.uid;
        }
        draw.set(featuresCollection);
      }, 500);
    },
    reset_features_properties() {
      this.is_loading_1 = true;
      setTimeout(() => {
        this.is_loading_1 = false;
        let draw = this.$store.state.draw;
        let featuresCollection = draw.getAll();
        for (let i in featuresCollection.features) {
          featuresCollection.features[i].properties = {};
        }
        draw.set(featuresCollection);
      }, 500);

    },
    clear_features_elements() {
      this.is_loading_1 = true;
      setTimeout(() => {
        this.is_loading_1 = false;
        let draw = this.$store.state.draw;
        let featuresCollection = draw.getAll();
        for (let i in featuresCollection.features) {
          delete featuresCollection.features[i].properties.element;
        }
        draw.set(featuresCollection);
      }, 500);
    },
    delete_all_features() {
      this.$dialog.confirm({
        message: "Are you sure?",
        type: "is-danger",
        onConfirm: () => {
          this.is_loading_2 = true;
          setTimeout(() => {
            this.is_loading_2 = false;
            this.$store.state.draw.deleteAll();
            this.$store.dispatch("update_vector_count");
          }, 500);
        },
      });
    },
  },
};
</script>
<style lang="scss" >
.nav-menu {
  .tab-content {
    padding: 1rem 3px;
    text-align: center;
  }
  .tabs ul {
    display: flex;
    justify-content: space-around;
    margin-left: 0;
    font-size: 0.9rem;
  }
  .tabs li {
    text-transform: capitalize;
  }
  .tabs a {
    border-bottom-width: 3px;
    border-bottom-color: transparent;
    color: #171e48;
    opacity: 0.5;
    font-family: Barlow-SemiBold !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    line-height: 19px !important;
    padding-bottom: 17px;
  }
  .tabs li.is-active a {
    opacity: 1;
    color: #171e48;
    border-bottom-width: 3px;
    border-bottom-color: #5c7ef7;
  }
}
.content .nav-menu li + li {
  margin-top: 0 !important;
}
.map_style {
  position: absolute;
  bottom: 0rem;
  right: -4rem;
  height: 3.5rem;
  border-radius: 6px;
  img {
    border-radius: 6px;
  }
  z-index: 30 !important;
}
</style>
